/* istanbul ignore file */
import { EnvVariables } from './types';

/**
 * NOTE: env variables are overridden in release pipeline.
 *  *.min.js file is edited and variables in config object are replaced with values from SSM.
 * */

const defaults = {
  NODE_ENV: 'development',
  API_KEY: '3_g0VqF7c6mmN3KYJCiEMdJOLF_lKb3h0qiXK6Uf1P17tLrbXpfY-P7ayDwBPIdFNR',
  CLIENT_ID: '-lcCkTux5TS-3K8eC7zWR6zl',
  PROXY_BASE_URL: 'https://proxy.dev.internal.sso.cambridge.org',
  FEEDBACK_SURVEY_URL: '#',
  FEATURE_FLAG_PROXY_URL:
    'https://unleash-proxy.dev.internal.sso.cambridge.org/proxy',
  FEATURE_FLAG_CLIENT_KEY:
    '7d8f8eb15e5b8e5346a40f1a226429144c1a45b0af541acf932a52dca979ba95',
  FEATURE_FLAG_APP_NAME: 'mycambridge',
  FEATURE_FLAG_REFRESH_INTERVAL: 30, // How often should it be checked for new values in seconds
  ORG_USERS_BASE_URL: 'https://orgs.dev.internal.sso.cambridge.org',
  ICP_LICENSE_STRING: 'ICPLICENSESTRING',
  IS_CHINA: false,
  GA_TRACKING_ID: 'UA-206614005-1',
  CAS_BPID: 'DEV_CAS001',
  CA_BPID: 'DEV_CA001',
  CDN_DATA_CENTER: 'cdns.eu1.gigya.com',
  HOTJAR_SITE_ID: '3831329',
};

const config = {
  NODE_ENV: '${NODE_ENV}',
  API_KEY: '${API_KEY}',
  CLIENT_ID: '${CLIENT_ID}',
  PROXY_BASE_URL: '${PROXY_BASE_URL}',
  FEEDBACK_SURVEY_URL: '${FEEDBACK_SURVEY_URL}',
  FEATURE_FLAG_PROXY_URL: '${FEATURE_FLAG_PROXY_URL}',
  FEATURE_FLAG_CLIENT_KEY: '${FEATURE_FLAG_CLIENT_KEY}',
  FEATURE_FLAG_APP_NAME: '${FEATURE_FLAG_APP_NAME}',
  FEATURE_FLAG_REFRESH_INTERVAL: '${FEATURE_FLAG_REFRESH_INTERVAL}',
  ORG_USERS_BASE_URL: '${ORG_USERS_BASE_URL}',
  ICP_LICENSE_STRING: '${ICP_LICENSE_STRING}',
  IS_CHINA: '${IS_CHINA}',
  GA_TRACKING_ID: '${GA_TRACKING_ID}',
  CAS_BPID: '${CAS_BPID}',
  CA_BPID: '${CA_BPID}',
  CDN_DATA_CENTER: '${CDN_DATA_CENTER}',
  HOTJAR_SITE_ID: '${HOTJAR_SITE_ID}',
};

const env = Object.keys(config).reduce((acc, curr): EnvVariables => {
  return {
    ...acc,
    [curr]: config[curr as keyof EnvVariables].startsWith('${')
      ? defaults[curr]
      : config[curr],
  } as EnvVariables;
}, {} as EnvVariables);

export default env;
